import React from 'react';
import Image from './Image';
import Text from './Text';
import FIBText from './FIBText';
import DisplayTemplate from '../displayTemplate';

export default function TextAndImage({ contentType, content, selected, disabled, enableTextToAudio, handleAnswerSelection, contentDisplayType, contentUrl, mediaStyle, overrideHTML, renderDefault = false, helpText, templateType, ...props }) {
    const ImageComponent = () => <Image renderDefault={true} mediaStyle={mediaStyle} contentUrl={contentUrl} {...props} />;

    const TextComponent = () => contentDisplayType == 'FIB' ? <FIBText disabled={disabled} value={selected} renderDefault={true} handleAnswerSelection={handleAnswerSelection} length={props.length} content={content} /> : <Text renderDefault={true} enableTextToAudio={enableTextToAudio} content={content} helpText={helpText} style={{ justifyContent: 'center' }} />;

    return <DisplayTemplate templateType={templateType} components={[TextComponent, ImageComponent]} {...props} />
}
